import { IonIcon } from '@ionic/react';
import { arrowBack, closeOutline } from 'ionicons/icons';
import React, { ReactNode, useRef } from 'react';
import useModalPresentation from './useModalPresentation';
import './Modal.css';

type Props = {
  title: ReactNode;
  titleId?: string;
  subtitle?: string;
  icon?: string;
  layout?: 'fullscreen' | 'compact' | 'responsive' | 'auto';
  onDismiss?: () => void;
  disabled?: boolean;
};

// responsive: tela inteira no celular e janela no desktop.
export default function ModalHeader({ title, titleId, subtitle, icon, layout = 'auto', onDismiss, disabled = false }: Props) {
  const ref = useRef<HTMLElement>(null);
  const presentation = useModalPresentation(ref);
  const resolvedLayout = layout === 'auto' ? presentation || 'responsive' : layout;
  return (
    <header ref={ref} className={`xeguei-modal-header xeguei-modal-header--${resolvedLayout}`}>
      {onDismiss && <button type="button" className="xeguei-modal-navigation xeguei-modal-back" aria-label="Voltar" disabled={disabled} onClick={onDismiss}>
        <IonIcon icon={arrowBack} aria-hidden="true" />
      </button>}
      <div className="xeguei-modal-heading">
        {icon && <span className="xeguei-modal-icon"><IonIcon icon={icon} aria-hidden="true" /></span>}
        <div><h2 id={titleId}>{title}</h2>{subtitle && <p>{subtitle}</p>}</div>
      </div>
      {onDismiss && <button type="button" className="xeguei-modal-navigation xeguei-modal-close" aria-label="Fechar" disabled={disabled} onClick={onDismiss}>
        <IonIcon icon={closeOutline} aria-hidden="true" />
      </button>}
    </header>
  );
}
